<ng-container *ngIf="!favorites && published">
    <app-exhibitors *ngIf="selector.tabs === tabs.ONLY_EXHIBITORS && loader.count === 0"></app-exhibitors>
    <app-products *ngIf="selector.tabs === tabs.ONLY_PRODUCTS && loader.count === 0"></app-products>
    <app-novelties *ngIf="selector.tabs === tabs.ONLY_NOVELTIES && loader.count === 0"></app-novelties>
    <app-brands *ngIf="selector.tabs === tabs.ONLY_BRANDS && loader.count === 0"></app-brands>
</ng-container>

<app-my-favorites *ngIf="favorites && loader.count === 0"></app-my-favorites>